ArchivedCardView = require 'views/archive/archived-card-view'
SearchHelpView = require 'views/archive/search-help-view'
Dates = require 'lib/dates'
Hearsay = require 'hearsay'
ModelLoader = require 'db/model-loader'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
l = require 'lib/localize'
f = require 'effing'
track = require 'debug/track'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'

module.exports = class ArchivedCardsView extends View
  CARDS_PER_PAGE: 30
  SEARCH_LIMIT: 50

  # Here's the big idea:

  # A "managed function" can't be invoked directly. It can only be "leased."

  # It can be leased multiple times, but every time you lease a function
  # you invalidate the previously leased function.

  # This prevents the case where we fire off two searches, the second one
  # completes first, then the first one completes and overwrites the result
  # of the second one (which is the only one we care about).

  # The *right* way to do this would be to make the modelLoader return
  # a cancelable promise, so that this isn't necessary. That's out of
  # the scope of this work, though, so we'll do this until that's ready.

  # This might move into effing.js, but honestly this is such an antipattern...
  magicInitialValue = {}
  managed = (baseFunction) ->
    latestLeasedFunction = magicInitialValue
    return lease: ->
      leasedFunction = ->
        if latestLeasedFunction == magicInitialValue ||
           leasedFunction == latestLeasedFunction
          baseFunction.apply(this, arguments)
        return
      latestLeasedFunction = leasedFunction
      return leasedFunction

  initialize: ({ @searchText }) ->
    @isLoadingInitialCards = @slot(false)
    @isLoadingMoreCards = @slot(false)
    @isLoadingSearchResults = @slot(false)
    @tooManySearchResults = @slot(false)

    @isLoading = @using @isLoadingInitialCards.or(@isLoadingSearchResults)

    @isSearching = @using @searchText.map((text) -> text.length > 0).distinct()
    @hasMoreCards = @slot(false)
    @searchResults = @slot([])
    @sortedContiguousCards = @slot([])

    @updateSearchCallback = managed (cardBlobs) =>
      cards = cardBlobs.map (cardData) =>
        @modelCache.get 'Card', cardData.id

      @tooManySearchResults.set cards.length == @SEARCH_LIMIT
      @searchResults.set cards
      @isLoadingSearchResults.set false

    pullCard = (card) =>
      @sortedContiguousCards.set _.without(@sortedContiguousCards.get(), card)
      @searchResults.set _.without(@searchResults.get(), card)

    @listenTo @modelCache,
      'remove:Card': pullCard
      'change:Card:closed': (card) =>
        unless card.get('idBoard') == @model.id
          return
        if card.get('closed')
          # because it just changed, it must be newer than everything else...
          @sortedContiguousCards.set [card, @sortedContiguousCards.get()...]
        else
          pullCard(card)
        return

    @cards = @using @isSearching.if(@searchResults, @sortedContiguousCards)

  events:
    'click .js-more-cards': 'getMoreCards'
    'click .js-show-search-tips': 'showSearchTips'

  # should effing once this baby
  hasBeenActiveBefore = false
  didBecomeActive: ->
    if @hasBeenActiveBefore
      return
    @hasBeenActiveBefore = true
    query =
      limit: @CARDS_PER_PAGE

    @isLoadingInitialCards.set true
    ModelLoader.loadClosedCards @model.id, query
    .tap f(@, 'didLoadContiguousCards')
    .finally =>
      @isLoadingInitialCards.set false
    .done()

  didLoadContiguousCards: (cards) ->
    @hasMoreCards.set cards.length == @CARDS_PER_PAGE
    sortedCards = _.sortBy cards, (card) => -@cardSortRank(card)
    result = [@sortedContiguousCards.get()..., sortedCards...]
    # If the results were actually contiguous or deterministic
    # or anything, the `uniq` call wouldn't be necessary. But.
    @sortedContiguousCards.set _.uniq(result)

  cardSortRank: (card) ->
    Dates.parse(card.get('dateLastActivity')).getTime?() ? null

  getMoreCards: ->
    # Although the load more button only appears initially if there are some
    # cards -- at least @CARDS_PER_PAGE, to be precise -- it's possible that
    # the user has *unarchived all of them* and then pressed the load more
    # cards button, so we have to guard against this.
    lastCard = _.last(@sortedContiguousCards.get())
    query =
      limit: @CARDS_PER_PAGE
      before: if lastCard? then @cardSortRank(lastCard) else null

    @isLoadingMoreCards.set true
    ModelLoader.loadClosedCards @model.id, query
    .tap f(@, 'didLoadContiguousCards')
    .finally =>
      @isLoadingMoreCards.set false
    .done()

  vigor: @VIGOR.SOME
  renderOnce: ->
    @$el.html templates.fill('archived_cards')

    @watch 'isLoadingMoreCards', (isLoadingMore) ->
      @$('.js-more-cards').attr 'disabled', isLoadingMore

    showLoadMoreButton = @hasMoreCards.and @isSearching.not()
    @subscribe showLoadMoreButton, (showLoadMoreButton) ->
      @$('.js-more-cards').toggleClass 'hide', !showLoadMoreButton

    @$('.js-search-message').html l('too many results',
      {
        limit: "<strong>#{@SEARCH_LIMIT.toString()}+</strong>"
        learnMoreLink: "<a class=\"js-show-search-tips\" href=\"#\">#{l('learn more')}</a>"
      },
      {
        raw: true
      }
    )
    showSearchMessage = @tooManySearchResults
    @subscribe showSearchMessage, (showSearchMessage) ->
      @$('.js-search-message').toggleClass 'hide', !showSearchMessage

    @watch 'isSearching', (isSearching) ->
      key = if isSearching
        'no results'
      else
        'no archived cards'
      @$('.js-empty-message').text l(key)

    @watch 'cards', (cards) ->
      @$('.js-empty-message').toggleClass 'hide', cards.length > 0

    @watch 'isLoadingSearchResults', (isLoadingSearchResults) ->
      @$('.js-search-loading').toggleClass 'hide', !isLoadingSearchResults

    debouncedSearch = @debounce @loadSearchResults, 400
    @subscribe @searchText.filter((text) -> text.length > 0), ->
      @isLoadingSearchResults.set true
      debouncedSearch.call(@)
    @subscribe @cards, @frameDebounce @renderCards

  loadSearchResults: ->
    query =
      query: "is:archived #{ @searchText.get() }"
      modelTypes: 'cards'
      idBoards: @model.id
      card_stickers: true
      card_attachments: 'cover'
      partial: true
      cards_limit: @SEARCH_LIMIT

    ModelLoader.loadSearchData query
    .get 'cards'
    .then @updateSearchCallback.lease()
    .done()

  renderCards: ->
    $archivedItems = @$('.js-archive-items')

    $archivedItems.children().detach()

    itemSubviews = for card in @cards.get()
      @subview ArchivedCardView, card,
        reOpenText: l('unarchive card')
        canDelete: true

    @appendSubviews itemSubviews, $archivedItems

    return

  showSearchTips: (e) ->
    Util.stop(e)

    track("Board Menu", "Archived Cards Search", "Learn More")

    PopOver.toggle
      elem: e.target
      view: SearchHelpView


    return



// WEBPACK FOOTER //
// ./app/scripts/views/archive/archived-cards-view.coffee